import React from 'react';
import Table from 'react-bootstrap/Table';
function Table2() {
    return (
        <div>
             <Table striped bordered hover size="sm" className="tab">
  <thead>
    <tr>
      <th className="bito">#</th >
      <th  className="bito">Pest</th>
      <th  className="bito">Habitat/Behavior on plants</th>
      
      
    </tr>
  </thead>
  <tbody>
    <tr  className="bito">
      <td>1</td>
      <td>Aphids</td>
      <td>Virtually every Plant has at least one aphid species that attacks it. There are about 4,000 species of aphids in the world, of which about 250 are serious pest.
These small insects are masters of reproduction and are found in great number of stems of leaves
Aphids are common pests of nearly all indoor and outdoor ornamental plants, as well as vegetables, fruits trees, and field crops. Aphid injures plants by directly removing plant juices (sap from phloem tissues) and causing plant stress.
</td>
     
     
    </tr>
    <tr  className="bito">
      <td>2</td>
      <td>Armyworms in corn</td>
      <td>The armyworm, or true armyworm, is a common early season pest that can cause occasional losses in corn and should be monitored for in the spring. Infestations usually first develop in fields of small grains or in other grass cover crops. In conventional tillage systems, partially- grown larvae can migrate into corn fields from grassy waterways or wheat fields, damage is usually first noticeable around the field margins adjacent to these areas. The name armyworm derives from its behavior of migrating in large numbers into fields similar to invading armies. 
        In no-till or reduced tillage systems, infestation may cover the entire field. 
        In these systems, eggs may be laid on grasses within the field prior to planting and herbicides may force armyworms to feed on corn as the weeds or cover crop dies. Cool, wet, spring weather usually favors armyworm development. 
Armyworms usually feed at night and damage corn by chewing leaves. They prefer to feed on the succulent leaves in the whorl first. Feeding is usually confined to leaf margins, but occasionally they may strip the entire plant leaving only the midrib of the leaves. During the day, armyworms are found in the soil or underneath ground cover. Ragged leaf feeding in the spring and early summer is evidence of armyworm feeding. Corn can usually recover from light to moderate feeding by armyworm without significant yield loss. However, severe damage, particularly if the growing bud is injured, can cause significant loss in yield.
</td>
      
     
     
    </tr>
    <tr  className="bito">
      <td>3</td>
      <td>Bean Leaf Beetle in Kentucky Soyabeans</td>
      <td>Bean Leaf Beetle in Kentucky Soyabeans
Adult bean leaf beetles prefer to eat tender young plant tissue.
High populations of adults can defoliate the first true leaves and kill young seedlings.
Extensive feeding can weaken the plant and reduce the yield. Black spots on beans due to bean leaf beetle feeding when pods form later in the season, adults will also feed on their outer surface. This feeding only affects the appearance of the pods. Bean leaf beetles are known to carry and spread some plant diseases. 
Fortunately, this is not an issue in home gardens, as most snap bean varieties are not affected by these diseases.
</td>
      

</tr>
<tr  className="bito">
      <td>4</td>
      <td>Cereal Leaf Beetle</td>
      <td>Adult cereal leaf beetles overwinter in and around grain fields in protected areas such as tree bark, straw stubble and underneath leaf and crop litter. Once they emerge from overwintering, the beetles will feed on grasses, moving into winter and late spring cereal crops. These cereal crops would include barley, brome grass, corn, oats, orchard grass, quackgrass, reed canary grass, rye, rye grass, timothy, wheat and a few other grasses.
         Adults and larvae consume the same host plants listed above; they will eat these plants by chewing between the veins of leaf tissue. Adult cereal leaf beetles are able to eat all the way through the leaves, whereas the larvae will only eat the top surface, leaving behind a window-pane or “skeletonizing” effect on the leaves. 
        When extensive damage has been done, the leaf turns a whitish colour and makes the plant look like it has been damaged by frost. If cereal leaf beetles are not managed, they are able to cause a serious reduction in yield.
         Note that most plant injury will occur by larva in June</td>
      
      
     
    </tr>

    <tr  className="bito">
      <td>5</td>
      <td>Locust</td>
      <td>Unlike most grasshoppers, locusts can form large groups or swarms.
         Desert locusts normally live in an area in a band across Africa south of the Sahara and into India. 
         When a locust plague occurs, the swarms move into Africa, Asia, Europe and beyond. 
         Swarms can migrate over huge distances. When locusts are on their own (i.e. not in swarms) they are called solitarious and they normally try to avoid each other, flying at night. The solitarious adults are coloured green. 
         When there are lots of locusts crowding together, often to find food, swarms can develop. 
         When locusts are about to swarm they not only change their behaviour, but if they are still nymphs, they will even grow up to look different as adults. These adults are multi-coloured, e.g. with black, pink and yellow areas. They are called gregarious forms. 
         A gregarious mother can also decide whether her offspring will be solitarious or gregarious. 
         Scientists have found that there is something in the protective foam around the eggs that may cause them to hatch into gregarious nymphs. </td>
     
</tr>

<tr  className="bito">
      <td>6</td>
      <td>Mormon cricket</td>
      <td>The Mormon cricket, a shieldbacked katydid (family Tettigoniidae, subfamily Decticinae) and not a true cricket, lives in western North America in rangeland dominated by sagebrush and forbs. Large populations develop in the open sagebrush-grass associations of the Great Basin and of mountain ranges. In the Rocky Mountains of Colorado, small resident populations occur from 6,500 feet in forest openings to above 11,000 feet in the alpine tundra.
Although the Mormon cricket has been observed to feed on more than 400 species of plants, this insect discriminates in its choice of foods, preferring certain succulent forbs. Examinations of crop contents and direct observations of feeding show that preferred forbs include milkvetches, penstemon, arrowleaf balsamroot, dandelion, and several mustards such as wild mustard, tumble mustard, and pepperweed. Among the abundant shrubs growing in its habitat, the Mormon cricket has often been observed feeding on saltbush and on species of sagebrush (big sagebrush, budsage, fringed sagebrush).
Despite its flightless state, the Mormon cricket is a very mobile insect. The first four instars move about extensively in search of food and shelter and in short migration. Their net travel is not far. 
</td>
      
       </tr>

       <tr  className="bito">
      <td>7</td>
      <td>True Bugs</td>
      <td>True bugs are found in nearly all land and freshwater habitats, except very coldest. The only group of insects that have evolved to live on the ocean are true bugs. True bug groups are most diverse and abundant in habitats on land that are moist and have a lot of plant life.	These animals are found in the following types of habitat
	temperate 
	tropical 
	polar 
	terrestrial 
	saltwater or marine 
	freshwater
	Terrestrial Biomes
	tundra 
	taiga 
	desert or dune 
	savanna or grassland 
	chaparral 
	forest 
	rainforest 
	scrub forest 
	mountains
	Aquatic Biomes
	pelagic 
	lakes and ponds 
	rivers and streams 
	temporary pools 
	brackish water
	Wetlands
	marsh 
	swamp 
	bog
	Other Habitat Features
	urban 
	suburban 
	agricultural 
	riparian 
	estuarine 
	intertidal or littoral
Different kinds of true bugs can be very different sizes. The smallest are only a few millimeters long. The largest, the cicadas, can sometimes be 50 millimeters long.
True bugs have lots of different shapes. They may have long or short antennae having four or five segments. Their legs are adapted for grasping or for walking, and sometimes for swimming. Some can fly, some have lost their wings. Many true bugs have scent glands on the sides of the thorax. These glands make stinky chemicals that repel predators.

</td>
     
       </tr>

       <tr  className="bito">
      <td>8</td>
      <td>Corn rootworm</td>
      <td>The western corn rootworm,Diabrotica virgifera, is one of the most devastating corn rootworm species in North America, especially in the mildwestern corn-growing areas such as lowa. A related species, the Northern corn rootworm, D. barberi, co-inhabits in much of the range and is fairly similar in biology.
        Corn rootworm larvae can destroy significant percentage of corn if left untreated.
</td>
      
       </tr>

      
    
  </tbody>
</Table>   
        </div>
    )
}

export default Table2;
